import axiosInstance from 'api/axiosInstance';
import { groupBy } from 'lodash';
import { stringify } from 'query-string';
import type {
  IPaginationRequest,
  IPaginationResponse,
} from 'types/pagination.types';
import type { AvailableCountries, AvailableLanguages } from 'types/users.types';

type GetAPCsParams = IPaginationRequest & {
  country: AvailableCountries;
  language: AvailableLanguages;
  name: string;
};

export type APC = { APC1: string; APC2: string };

type Response = IPaginationResponse & {
  data: APC[];
};

export type GroupedOption = {
  label: string;
  options: (APC & { label: string; value: string })[];
};

// type Return = IPaginationResponse & {
//   data: GroupedOption[];
// };

export const apcToOption = (apc: APC) => ({
  ...apc,
  label: apc.APC2,
  value: apc.APC1 + '@' + apc.APC2,
});

const getAPCs = (params: GetAPCsParams): Promise<Response> => {
  return axiosInstance.get(
    '/v2/users/accountable-professional-codes?' +
      stringify(params, { skipEmptyString: true, skipNull: true }),
  );
};

export const groupAPCs = (APCs: APC[]): GroupedOption[] => {
  const options = APCs.map(apcToOption);
  const grouped = groupBy(options, 'APC1');
  const groupedOptions = Object.entries(grouped).map(([label, options]) => ({
    label,
    options,
  }));
  return groupedOptions;
};

type MaybeAPC =
  | APC
  | {
      APC1: null;
      APC2: null;
    };

export const getAPCFromNACE = (nacecode: number): Promise<APC | undefined> => {
  return axiosInstance
    .get<any, MaybeAPC>(`/v2/users/accountable-professional-codes/${nacecode}`)
    .then((maybeAPC) => {
      if (!maybeAPC.APC1) return;
      return maybeAPC;
    });
};

export default getAPCs;
